<template>
  <button type="button" class="col-sm-12 btn btn-success" @click="showHistory()">
    {{ trans('client.common.wallet_modal_title_button') }}
  </button>
</template>

<script>
import bootbox from 'bootbox'

export default {
  props: {
    clientId: {
      type: [Number, String],
      default: null,
    },
  },
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
    showHistory: function () {

      let dialog = bootbox.dialog({
        title: Translator.trans('client.common.wallet_modal_title'),
        message: `<p><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> ${Translator.trans('common.loading')} </p>`,
        backdrop: true,
        onEscape: true,
        className: 'history-modal',
        size: 'large',
        buttons: {
          cancel: {
            label: Translator.trans('common.close'),
            className: 'btn btn-default',
            callback: function () {
              dialog.modal('hide')
            }
          },
        }
      })
      let url = Routing.generate('api_get_client_wallet_history', { id: this.clientId,
        _format: 'html' })

      this.$http.get(url).then(response => {
        dialog.find('.bootbox-body').html(response.data)
      }, response => {

        this.handleAjaxError(response)
      })
    },
    trans(id) {
      return Translator.trans(id)
    }
  },
}
</script>
